import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { ACCESS_TOKEN_NAME } from "../shared/constant";
import { retrieveUserDetails } from "../redux/actions/userActions";
import { RootState } from "../redux/rootReducer";
import ROUTES from ".";
import { isAccountsORManager, isManager } from "../utils/clapUtils";

function PrivateRoute({ children }: { children: JSX.Element }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const [isCheckingUser, setIsCheckingUser] = useState(true);
  const { userDetails, userDetailsSuccess } = useSelector(
    (state: RootState) => state.user,
  );
  const token = localStorage.getItem(ACCESS_TOKEN_NAME) || "";

  // PrivateRoute mounted
  useEffect(() => {
    if (token) dispatch(retrieveUserDetails());
  }, []);

  useEffect(() => {
    if (userDetailsSuccess) setIsCheckingUser(false);
  }, [userDetailsSuccess]);

  if (!token)
    return <Navigate to={ROUTES.PATHS.LOGIN} state={{ from: location }} />;

  if (isCheckingUser) return <div />;
  if (!isCheckingUser) {
    // if (userDetails.status === Status.INACTIVE) {
    //   return <Navigate to={ROUTES.PATHS.INACTIVE_ACCOUNT} />;
    // }

    // TODO add inactive account path, sothat can't access
    if (isManager(userDetails)) {
      if (
        location.pathname.includes(ROUTES.PATHS.ADMIN.PAYMENTS) ||
        location.pathname.includes(ROUTES.PATHS.ADMIN.INCOME)
      )
        return <Navigate to={ROUTES.PATHS.ADMIN.TRACKS} />;
    }

    if (isAccountsORManager(userDetails)) {
      if (
        [
          ROUTES.PATHS.ADMIN.HOME,
          ROUTES.PATHS.ADMIN.SALESDATA,
          ROUTES.PATHS.ADMIN.USERS,
          ROUTES.PATHS.ADMIN.SIGNUP_REQUESTS,
        ].includes(location.pathname) ||
        location.pathname.includes(ROUTES.PATHS.ADMIN.CLIENTS) ||
        location.pathname.includes(ROUTES.PATHS.ADMIN.INVOICES)
      ) {
        return <Navigate to={ROUTES.PATHS.ADMIN.TRACKS} />;
      }
    }
    return children;
  }
  return <div />;
}

export default PrivateRoute;
